import { createReducer } from "@reduxjs/toolkit";
import { createProviderStudio, resetCreateProviderStudio } from "./create-provider-studio";
import type { CreationState } from "@redux/state/shared-types";

const initialState: CreationState = {
  processing: "idle",
  justCreatedId: null,
};

export const createProviderStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(createProviderStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(createProviderStudio.fulfilled, (state, action) => {
      state.processing = "success";
      state.justCreatedId = action.payload;
    })
    .addCase(createProviderStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetCreateProviderStudio, () => {
      return initialState;
    });
});
